import React from 'react';
import { Link, SimpleGrid, Card, Image, AspectRatio } from '@chakra-ui/react';

import ImpactReportLayout from '../../../../../components/layouts/impactreport';
import TableOfContents from '../../../../../components/sections/tableofcontents';

import empoweringPeopleHeroImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/empowering_people_hero.jpg';

import ImpactReporth2 from '../../../../../components/sections/impactreport/impact-h2';
import ImpactReporth3 from '../../../../../components/sections/impactreport/impact-h3';
import ImpactReporth4 from '../../../../../components/sections/impactreport/impact-h4';
import ImpactReporth5 from '../../../../../components/sections/impactreport/impact-h5';
import ImpactReportPrevNextNav from '../../../../../components/sections/impactreport/prev-next-nav';

// Images
import club1938Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/club-1938_1.jpg';
import kayakingImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/water_exploration.jpg';
import clubHikingImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/club_hiking.jpg';

import vietnamSportDay1Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/vietnam_spotlight_sport-day_1.jpg';
import vietnamSportDay2Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/vietnam_spotlight_sport-day_2.jpg';
import vietnamSportDay3Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/vietnam_spotlight_sport-day_3.jpg';
import vietnamSportDay4Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/vietnam_spotlight_sport-day_4.jpg';

import planetWaterImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/aqua_tower.jpg';
import raiseAglassImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/planet_water_glasses.jpg';

import amgaImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/amga.webp';

import leaveNoTrace1Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/leave_no_trace_1.jpg';
import leaveNoTrace2Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/leave_no_trace_2.jpg';

import myWellBeingImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/my_wellbeing.jpg';

import pranaGreenTeam1Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/prAna_Green_Team_1.jpg';
import pranaGreenTeam2Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/prAna_Green_Team_2.jpg';

import tctImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/tct.jpg';

import volunteerImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/Employee_Volunteer.jpg';
import volunteer2Img from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/Employee_Volunteer_2.jpeg';

import charityCheckOutImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/charity_check_out_image.png';

// ERN Logos
import benLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/ben_logo.png';
import bravoLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/bravo_logo.png';
import capeLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/cape_logo.png';
import ourTrailLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/ourTrail_logo.png';
import prideLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/pride_logo.png';
import vamosUnidosLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/vamosUnidos_logo.png';
import wliLogoImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/ern-logos/wli_logo.png';


// Charts
import workforceLevelGenderImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/csc_workforce_level_gender.png';
import workforceLevelEthnicityImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/csc_workforce_level_ethnicity.png';
import workforceRoleGenderImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/csc_workforce_role_gender.png';
import workforceRoleEthnicityImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/csc_workforce_role_ethnicity.png';
import workforceRegionImg from '../../../../../components/ui/corporateresponsibility/impact/2024-impact-report/empowering-people/csc_workforce_by_region.jpg';

export default function TwentyTwentyFourImpactReportEmpowringPeople() {

    const links = [
        {
            title: "About Us and 2024 Highlights",
            href: "/corporate-responsibility/impact/2024",
            active: false
        },
        {
            title: "Empowering People",
            //href: "/corporate-responsibility/impact/2024/empowering-people",
            active: true
        },
        {
            title: "Sustaining Places",
            href: "/corporate-responsibility/impact/2024/sustaining-places",
            active: false
        },
        {
            title: "Responsible Practices",
            href: "/corporate-responsibility/impact/2024/responsible-practices",
            active: false
        },
        {
            title: "Appendices",
            href: "/corporate-responsibility/impact/2024/appendices",
            active: false
        }
    ];

  const ErnCards = [
    {
        title: 'Vamos Unidos',
        description: 'Since 2022, Vamos Unidos has partnered with Vámonos Outside to support Latino and Hispanic youth getting outside. The organization promotes an inclusive outdoor culture in Central Oregon by offering recreation opportunities for Latino and BIPOC communities. In 2024, Vamos Unidos donated ski kits and sun protection tops to youth participants and helped amplify Vámonos Outside’s impact by hosting the Vámonos Al Cine Film Festival in celebration Earth Month. The festival featured films by Hispanic and Latino filmmakers, highlighting life in the outdoors and the mission of Vámonos Outside. Through this partnership, we’re helping introduce more people to the outdoors and equipping them with the gear they need to enjoy it.',
        logo: `${ vamosUnidosLogoImg }`
    },
    {
        title: 'Women’s Leadership Initiative (WLI)',
        description: 'WLI offers year-round programming for all employees. Highlights include Women’s History Month celebrations, a farmers\' market at our Portland HQ featuring local women-owned businesses, inspiring career chats, and support for three community partners: Rose Haven, Dress for Success Oregon, and Days for Girls.',
        logo: `${ wliLogoImg }`
    },
    {
        title: 'Black Employee Network (BEN) & Friends ',
        description: 'BEN supported several organizations with product donations, including Youth for a Better Future, Orange County Heritage Council, and the Urban League of Greater Pittsburgh. In addition, they hosted Black History Month trivia and a cooking demonstration with chef and author Althea Brown.',
        logo: `${ benLogoImg }`
    },
    {
        title: 'PRIDE',
        description: 'In 2024, the PRIDE ERN hosted a speaker series called Human Connections. They also celebrated Pride Month by participating in the Portland Pride Parade and donating product to local queer nonprofits supporting LGBTQ+ youth. Additionally, PRIDE collaborated with other ERNs to make a monetary donation to the Cascade AIDS Project.',
        logo: `${ prideLogoImg }`
    },
    {
        title: 'Coalition of Asian & Pacific Islander Employees (CAPE)',
        description: 'CAPE celebrated Lunar New Year with a festive event featuring dragon and lion dances, and honored AAPI Heritage Month with Tai Chi, calligraphy, and origami activities. The team also gave back to the community by volunteering with the Immigrant and Refugee Community Organization, with participation from employees at our Rivergate Distribution Center.',
        logo: `${ capeLogoImg }`
    },
    {
        title: 'BRAVO',
        description: 'BRAVO (Bringing Representation and Valor to the Outdoors) supported veterans in our community through several initiatives, including participation in a Memorial Day Ruck March and contributions to the Minnesota Assistance Council for Veterans, the Hillsboro Stand Down, and Toys for Tots.',
        logo: `${ bravoLogoImg }`
    },
    {
        title: 'Our Trail',
        description: <>Our Trail focused on allyship and supporting all ERNs through collaborative events. The group also hosted a virtual <i>Lunch and Learn</i> titled “How to Be an Ally,” which was open to all employees.</>,
        logo: `${ ourTrailLogoImg }`
    },   
  ]

    const ReportNav = () => {
        return ( 
        <>
            <div>
                <nav id='main-report-nav'>
                    <ul className='nav-list'>
                        {links.map(link => (
                            link.active === false ? (
                            <li key={link.title}>
                                <Link href={link.href} className='nav-link'>
                                    <span className='nav-link__text'>{link.title}</span>
                                </Link>
                            </li>
                            ) :
                            (
                                <li className='active' key={link.title}>
                                    <span className='nav-link__text'>{link.title}</span>
                                    <TableOfContents />
                                </li>
                            )
                        )
                        )}
                    </ul>
                </nav>
            </div>
        </>
        );
      }
    

    function Hero() {
        return(<>
            <section>
                <div className='hero-main height-100'>
                    <div className='hero-main__container'>
                    <div className='hero-main__inner-container'>
                        <div className='hero-main__inner center-left is-top is-left'>
                            <figure className='hero-main__quote'>
                                <div className='hero-main__quote-icon'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="var(--csc-green)" stroke="currentColor" strokeWidth="0" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-quote-icon lucide-quote"><path d="M16 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/><path d="M5 3a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2 1 1 0 0 1 1 1v1a2 2 0 0 1-2 2 1 1 0 0 0-1 1v2a1 1 0 0 0 1 1 6 6 0 0 0 6-6V5a2 2 0 0 0-2-2z"/></svg>
                                </div>
                                <blockquote>
                                   At Columbia, we believe that empowering our employees goes hand in hand with uplifting the communities where we live and work.
                                </blockquote>
                                <figcaption>
                                    &mdash; Richelle Luther<br />Corporate Affairs & Chief HR Officer
                                </figcaption>
                            </figure>
                        <div className='hero-main__text container'>
                            <div className="hero-main__content cover-bubble" style={{ backgroundColor: 'var(--csc-green)'}}>
                                <div style={{ color: 'black' }}>
                                    <h1>Empowering<br />People</h1>
                                    <p>Supporting and uplifting the communities where we live, work, and play is at the heart of what we do. Our key areas of focus include our employees, our supply chain, and our communities.</p>
                                </div>
                            </div>
                        </div>
                        </div>
                        <div className='hero-main__video-container'>
                            <img src={empoweringPeopleHeroImg} alt='' />
                        </div>
                        <div className='hero-main__overlay'></div>
                    </div>
                    </div>
                </div>
            </section>
        </>)
    }
    
    return (
        <ImpactReportLayout
            reportTitle="2024 CSC Impact Report"
            sidebar={<ReportNav />}
            reporthero={<Hero />}
            pdfUrl="/pdfs/2024-impact-report.pdf"
        >
            <title>2024 Impact Report - Empowering People</title>
            <meta name="description" content="Highlights Columbia Sportswear Company's commitment to supporting our employees and communities." />

            <section>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-green)'}}>Our Employees</ImpactReporth2>
                    <ImpactReporth3>Employee Wellbeing</ImpactReporth3>
                    <p>
                        Columbia Sportswear Company’s (“CSC”) wellbeing program is designed to support employees in every aspect of their life – both inside and outside of the workplace. CSC’s wellbeing philosophy is centered around five pillars: physical, social/emotional, financial, career, and community.
                    </p>
                </div>
            </section>
            <section style={{ marginTop: 'var(--space-l)' }}>
                <div className='container flow'>
                    <ImpactReporth4 className='spotlight-heading'><span className='spotlight-sub'>U.S. Spotlight:</span><br />myWellbeing Program</ImpactReporth4>
                    <Image src={myWellBeingImg} alt='People camping' />
                     <p>
                        In 2023, CSC introduced the myWellbeing reimbursement program for U.S. full-time employees, which provides employees with the opportunity to be reimbursed for their wellness activities. In 2024, CSC reimbursed employees with over $285,000 on approximately 1,300 unique program requests towards various employee wellness activities.
                    </p>
                    <p>
                        Employees have used their myWellbeing reimbursement for various activities including: 
                    </p>
                    <ul>
                        <li>Gym memberships</li>
                        <li>Running shoes</li> 
                        <li>Camping gear</li>
                        <li>Massage therapy</li>
                        <li>Ski lift tickets</li>
                        <li>Fitness classes</li>
                    </ul>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-l)' }}>
                <div className='container flow'>
                    <ImpactReporth4 className='spotlight-heading'><span className='spotlight-sub'>China Spotlight:</span><br />Club 1938</ImpactReporth4>
                    <Image src={kayakingImg} alt='kayaking' className='kayaking' />
                     <p>
                        Club 1938 is an outdoor program for our employees based in China, providing a virtual hub for sharing tips and ideas to increase knowledge about the outdoors. In 2024, the club held two off-site activities.
                    </p>
                    <p>
                        The first trip included over 120 employees who embarked on a two-day trip in Tonglu, Zhejiang Province. Day one focused on learning wilderness survival skills, while day two featured a 10km hike with participants collecting trash along the route.
                    </p>

                    <AspectRatio ratio={16 / 9}>
                        <iframe 
                            src="https://www.youtube.com/embed/H9H4Zu9nQ4o?si=Ddzc5AVLKTqc7S-P" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerPolicy="strict-origin-when-cross-origin" 
                            allowFullScreen
                        />
                    </AspectRatio>
                    <p>
                        The second trip of the year included over 100 employees from three offices who participated in a half-day offsite activity. Participants chose from a variety of indoor and outdoor activities, ranging from a city walk to nature exploration.
                    </p>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={1}>
                        <Image src={club1938Img} alt='Club 1938' />
                        <Image src={clubHikingImg} alt='Club 1938 Hike' />
                    </SimpleGrid>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-l)' }}>
                <div className='container flow'>
                    <ImpactReporth4 className='spotlight-heading'><span className='spotlight-sub'>Vietnam Spotlight:</span><br /> Sports Day</ImpactReporth4>
                    <p>
                        To promote health awareness, the Vietnam team launched Sports Day, an event where employees participated in games designed to foster teamwork, strategy, and perseverance. The day was a great success, filled with competition, laughter, and team bonding. One employee shared, “When we play together, we grow together—and that’s what makes us unstoppable!”
                    </p>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={1}>
                        <Image src={vietnamSportDay1Img} alt='Vietnam Sports Day 1' />
                        <Image src={vietnamSportDay2Img} alt='Vietnam Sports Day 2' />
                        <Image src={vietnamSportDay3Img} alt='Vietnam Sports Day 3' />
                        <Image src={vietnamSportDay4Img} alt='Vietnam Sports Day 4' />
                    </SimpleGrid>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth3>Talent Development</ImpactReporth3>
                    <p>
                        The mission of CSC’s Talent Development team is to promote a culture of continuous learning by designing and delivering resources and workshops that enhance skill growth, performance impact, and career experience for all employees.
                    </p>

                    
                        <ImpactReporth4>
                            Leadership Excellence Acceleration Program (LEAP)
                        </ImpactReporth4>
                        <p>
                            LEAP welcomed 45 CSC leaders from 10 countries to participate in a six-month global leadership development acceleration program. Designed to elevate the leadership capabilities of high-potential people managers, LEAP helps participants become more inspired, developed, and connected to drive the future of leadership at Columbia Sportswear Company. The 2024 cohort was hosted entirely virtually, with participants engaging in workshops, self-led coaching circles, one-on-one sessions with senior leaders, and e-learning courses to hone their leadership skills.
                        </p>
                    
                        <ImpactReporth4>
                            The Amazing Race Development Program: China
                        </ImpactReporth4>
                        <p>
                            Our leadership development program in China, The Amazing Race, is designed to equip managers with the skills and insights necessary to thrive in today’s complex business landscape. Through a blended learning approach, participants deepen their expertise in two key areas: Leading Teams and Leading Business. The curriculum combines curated LinkedIn Learning courses with immersive sandbox simulation workshops, empowering participants to apply their newfound knowledge to real-world business challenges and deliver results in dynamic markets.
                        </p>
                    
                        <ImpactReporth4>
                            Unlock Your Potential: Europe
                        </ImpactReporth4>
                        <p>
                            Since 2022, the teams in Europe have actively promoted internal mobility through the Unlock Your Potential program. This initiative features a video and newsletter series that highlight employee success stories and showcase career growth across multiple roles within the company. This content is designed to encourage employees to pursue development and growth opportunities within Columbia.
                        </p>
                         <AspectRatio ratio={16 / 9}>
                            <iframe 
                                src="https://www.youtube.com/embed/qgGhuxuP8TE?si=xHwk-3yazRybHucQ" 
                                title="YouTube video player" 
                                frameborder="0" 
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                                referrerpolicy="strict-origin-when-cross-origin" 
                                allowfullscreen
                            />
                        </AspectRatio>
                    
                        <ImpactReporth4>
                            Retail Virtual Mentorship Event: North America
                        </ImpactReporth4>
                        <p>
                            In 2024, the Women’s Leadership Initiative Employee Resource Network, in partnership with the North America retail team, hosted a virtual mentoring event focused on promoting career mobility. The event connected high-performing retail talent with HQ business partners to build relationships, increase visibility into career paths, and encourage internal mobility by showcasing existing retail talent. Participants identified their top career interest and were paired with a female mentor from that division. During the event, participants learned about their mentor’s career journey, gained insight into that area of the business, and asked questions about career advancement. Mentors successfully established connections with key talent in the field and gained insights into retail's transferable skills, fostering mobility from field roles to corporate positions.
                        </p>
                    
                        <ImpactReporth4>
                            Manager Fundamentals
                        </ImpactReporth4>
                        <p>
                            In 2024, CSC grew the global Manager Fundamentals program, reinforcing our commitment to developing strong leaders. The program combines self-guided courses and live workshops to build managerial skills, foster community, and promote a culture of continuous learning. This year, leaders around the world completed over 1,900 courses, resulting in high engagement and satisfaction. The program continues to redefine effective management while strengthening our leadership pipeline across the Company.
                        </p>
                    
                        <ImpactReporth4>
                            Employee Development Workshops
                        </ImpactReporth4>
                        <p>
                            In July 2024, we launched the Employee Development Workshops program, offering monthly sessions for employees at all levels focused on building foundational skills. Since its inception, the program has covered six skill areas across 12 virtual and in-person workshops, with over 200 participants from the U.S., Canada, France, and India.
                        </p>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth3>Company Culture & Employee Resource Networks</ImpactReporth3>
                    <p>
                        Our ongoing commitment to an inclusive environment for our diverse workforce is reflected in our continued efforts to foster a workplace where everyone feels a true sense of belonging and inclusion. In 2024, we advanced our work by refining our operating model, strengthening our pillars, and further empowering our seven Employee Resource Networks (ERN), which are open to all employees. These networks now have structured roles, defined terms, and deeper integration with our business strategy, ensuring our efforts remain both robust and responsive to a changing world. Each ERN is employee-run, supported by an Executive Sponsor, and partnered with a non-profit organization. We also reinforce inclusive leadership with sponsorship of senior leader training sessions.Our seven CSC Employee Resource Networks are:
                    </p>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={10} className='erg-grid'>
                        {ErnCards.map((card, index) => (
                            <Card.Root key={index} borderColor={'var(--csc-green)'}>
                                <div style={{ height: '200px', padding: 'var(--card-padding) var(--card-padding) 0 var(--card-padding)' }}>
                                    <Image src={card.logo} alt='' style={{ height: '100%' }}  />
                                </div>
                                <Card.Body>
                                    <ImpactReporth4>{card.title}</ImpactReporth4>
                                    <Card.Description style={{ '--body-text-size': 'var(--step--1)' }}>{card.description}</Card.Description>
                                </Card.Body>
                            </Card.Root>
                        ))}
                    </SimpleGrid>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)', '--spotlight-color': 'var(--csc-green)' }} className='product-spotlight'>
                <div className='container flow'>
                    <ImpactReporth3>Community Group Spotlights</ImpactReporth3>

                    <ImpactReporth4>Green Teams</ImpactReporth4>
                    <p>Employee-run Green Teams support sustainability initiatives across our offices by hosting events and turning employee ideas into action. In 2024, the prAna and Geneva Green Teams each organized clothing swap events. prAna also hosted a natural dye workshop and a seed bomb-making activity.</p>
                    <SimpleGrid columns={2} gap={1}>
                        <Image src={pranaGreenTeam1Img} alt='prAna employee showing off denim' />
                        <Image src={pranaGreenTeam2Img} alt='prAna employees working on a project' />
                    </SimpleGrid>

                    <ImpactReporth4>Mountain Hardwear Inclusion, Diversity, Equity, Action (I.D.E.A.)</ImpactReporth4>
                    <p>Mountain Hardwear’s I.D.E.A. (Inclusion, Diversity, Equity and Action) group plans diversity and inclusion activities for employees and amplifies corporate diversity and inclusion initiatives. In 2024, the group supported a Giving Tuesday campaign that benefitted five nonprofits in the Bay Area.</p>

                    <ImpactReporth4>Inclusion at our Cambrai, France Distribution Center</ImpactReporth4>
                    <p>Our Cambrai, France Distribution Center team was honored by the Cambrésis Agglomeration Community and the sub-prefect for fostering an inclusive workplace. The team remains committed to creating an environment where employees feel welcome, valued, and supported in their roles. This annual recognition celebrates everyday business practices that promote a more inclusive society in France and a more connected global community.</p>

                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth3>Our Workforce at a Glance</ImpactReporth3>
                    <p>
                        This data is collected as part of our routine reporting process and is provided voluntarily by employees, who value the opportunity to share this information. The company does not maintain specific targets related to these categories.
                    </p>
                    
                    <ImpactReporth4 className='pill-header pill-border' style={{ backgroundColor: 'var(--csc-green)', borderColor: 'var(--csc-green)' }}>Workforce by Level</ImpactReporth4>
                    <figure className='table-img'>
                        <Image src={workforceLevelGenderImg} alt='Workforce by gender' className='gender-img' />
                    </figure>
                    <figure className='table-img'>
                        <Image src={workforceLevelEthnicityImg} alt='Workforce level by ethnicity' className='ethnicity-img' />
                    </figure>
                    
                    <ImpactReporth4 className='pill-header pill-border' style={{ backgroundColor: 'var(--csc-green)', borderColor: 'var(--csc-green)' }}>Workforce by Role</ImpactReporth4>
                    <figure className='table-img'>
                        <Image src={workforceRoleGenderImg} alt='Workforce role by gender' className='gender__role-img' />
                    </figure>
                    <figure className='table-img'>
                        <Image src={workforceRoleEthnicityImg} alt='Workforce role by ethnicity' className='ethnicity__role-img' />
                    </figure>

                    <ImpactReporth4 className='pill-header pill-border' style={{ backgroundColor: 'var(--csc-green)', borderColor: 'var(--csc-green)' }}>Workforce by Region</ImpactReporth4>
                    <figure className='table-img'>
                        <Image src={workforceRegionImg} alt='Workforce by region' className='region-img' />
                    </figure>

                    <div className='section-footnotes'>                        
                        <p style={{fontSize: 'var(--step--1)'}}><sup>*</sup>U.S. only</p>
                        <p style={{fontSize: 'var(--step--1)', marginTop: 0}}><sup>**</sup>Includes individuals who selected “undisclosed” as well as those who left the question blank</p>
                    </div>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-green)'}}>Our Supply Chain</ImpactReporth2>
                    <ImpactReporth3>CSC Clean Drinking Water Program</ImpactReporth3>
                    <AspectRatio ratio={16 / 9}>
                        <iframe 
                            src="https://www.youtube.com/embed/gC4QI_zAiQQ?si=7cavuLUuF-gafGbq" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen
                        />
                    </AspectRatio>
                    <p>
                        To combat the global water crisis and improve access to clean drinking water, we continue our partnership with <a href='https://www.columbia.com/planet_water_foundation.html?srsltid=AfmBOopR77zlj3TM_IlezwRpWQTfi_4PBr0tjo8ih8vJH1RSXNTga7RM' target='_blank' rel='noreferrer noopener'>Planet Water Foundation</a>, a U.S. nonprofit, to build AquaTowers (water filtration systems) in areas where CSC products are made.
                    </p>
                    <p>
                        The Planet Water AquaTowers provide numerous benefits:
                    </p>
                    <ul>
                        <li>Access to safe drinking water for communities where our products are made</li>
                        <li>Clean water for up to 1,800 people per tower, per day</li>
                        <li>Hygiene education for students at each tower installation site</li>
                        <li>Team-building opportunities with our factory vendors</li>
                    </ul>
                    <p>
                        <strong>Our goal:</strong> Provide clean drinking water to 100,000 people daily by 2028. 
                    </p>
                    <p>
                        <strong>Progress to date:</strong> As of 2024, we’ve reached over 80% of our goal as we work towards providing access to clean water for 100,000 people per day.
                    </p>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={1}>
                        <Image src={planetWaterImg} alt='An Aqua Tower' />
                        <Image src={raiseAglassImg} alt='Planet water' />
                    </SimpleGrid>
                    <p>
                        In 2024, we proudly partnered with Planet Water Foundation and our factory vendors to build ten AquaTowers in manufacturing communities. One tower was a joint initiative between Columbia and seven of our licensees, underscoring our shared commitment to the regions where we produce goods.
                    </p>
                    <p>
                        Two additional AquaTowers were built in partnership with vendors that produce prAna products – one in Vietnam and one in Guatemala.
                    </p>
                    <p>
                        In recognition of these efforts, Columbia Sportswear Company was honored in 2024 by AmCham Vietnam for its positive impact through clean water initiatives.
                    </p>

                    <a 
                        className='btn btn-black btn-normal pill-border'
                        style={{ display: 'inline-block', marginBlock: 'var(--space-m)'}} 
                        href='https://www.prana.com/life/sustainability/planet-water-foundation.html?srsltid=AfmBOorCqACsyMWySPG8NwmpSmih2vi5SNeRFytjD6NjwcJ3oBeiYiB8' 
                        target='_blank' 
                        rel='noreferrer noopener'
                    >
                            Learn More
                    </a>

                    <div className='quote__content'>
                        <div className='prose-content flow container'>
                            <blockquote>
                                "We are truly grateful for the AquaTower and Hygiene Education Program that Columbia Sportswear Company and Zuntex provided to our school. This project will benefit our children and the entire community." 
                            </blockquote> 
                            <div className='signature'>
                                <p>Yosselin Aceituno, Teacher, Escuela Oficial Rural Mixta de Los Rios, San Vicente Pacay, Guatemala</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth2 style={{ color: 'var(--csc-green)'}}>Our Communities</ImpactReporth2>
                    <ImpactReporth3>Employees Get Involved</ImpactReporth3>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={1}>
                        <Image src={volunteer2Img} alt='Employees volunteering' />
                        <Image src={volunteerImg} alt='Employees volunteering' />
                    </SimpleGrid>
                    
                    <p>
                        At CSC, we prioritize making time and space for team members to stay involved in their communities. That’s why our Volunteer Time-off Policy provides eligible employees with 16 hours of paid time off each year to support causes that matter most to them.
                    </p>
                    <p>
                        Employees consistently share that this policy allows them to use their time and energy to make a meaningful impact, while also feeling supported by the business. In 2024 alone, team members logged over 6,100 volunteer hours. And, all full-time, global employees can receive up to $1,000 per year of matched funds for nonprofit donations of their choosing.
                    </p>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth3>Donations</ImpactReporth3>
                    <ImpactReporth4>Employee Store Community Cares Program</ImpactReporth4>
                    <p>
                        We partner with local nonprofits by inviting their supporters to shop at our exclusive Employee Stores. This special access allows them to purchase products from our family of brands – Columbia Sportswear, SOREL, Mountain Hardwear, and prAna – at a discounted price. Ten percent of the total net sales from these visits is then donated back to the nonprofit.
                    </p>

                    <ImpactReporth4>Tough Mother Funder</ImpactReporth4>
                    <p>
                        Through our Tough Mother Funder, the Columbia brand invites U.S. customers to donate to selected nonprofit organizations at the register. In 2024, the program supported four different organizations, including the Land Trust Alliance, the National Park Foundation, and Captains for Clean Water. In response to Hurricane Helene in September 2024, the featured organization shifted to the Center for Disaster Philanthropy to aid in relief efforts.
                    </p>
                    
                    <ImpactReporth4>Disaster Relief</ImpactReporth4>
                    <p>
                        Columbia is committed to supporting disaster relief efforts in the regions where we operate and sell our products. In 2024, we provided aid in response to several disasters, including Hurricane Helene in the Southeast United States and severe flooding in Eastern Spain.
                    </p>

                    <ImpactReporth5>Southeast United States Hurricane</ImpactReporth5>
                    <ul>
                        <li>Monetary donation to the Center for Disaster Philanthropy.</li>
                        <li>Consumer donations made in all Columbia U.S. retail stores supported the Center for Disaster Philanthropy’s Helene Fund for designated period.</li>
                        <li>Product Donations provided to local organizations supporting disaster relief.</li>
                        <li>Employees were encouraged to donate through the CSC Community Impact Portal to receive a company match.</li>
                    </ul>

                    <Image src={charityCheckOutImg} alt='Charity Check Out Image' />

                    <ImpactReporth5>Eastern Spain Floods</ImpactReporth5>
                    <ul>
                        <li>Monetary donation to Cruz Roja Española.</li>
                        <li>Employees were encouraged to donate through the CSC Community Impact Portal to receive a company match.</li>
                    </ul>
                   
                    
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <ImpactReporth3>Community Impact</ImpactReporth3>
                    <ImpactReporth4>Collegiate Outdoor Recreation Program</ImpactReporth4>
                    <p>
                        Columbia, prAna, and Mountain Hardwear support the Collegiate Outdoor Recreation Program, helping over 71,000 students access the clothing and equipment they need to safely and comfortably enjoy the outdoors based on the most recent available 2023 data year. Many college students face barriers to accessing high-quality outdoor gear due to cost, limited storage space, or accessibility. By donating clothing and equipment to outdoor programs at 16 universities in the U.S., our brands help students experience everything from remote mountain climbs to urban park adventures.
                    </p>
                    <p>
                        College campus outdoor recreation offices organize activities like hiking, skiing, and climbing, introducing students to pursuits they may have otherwise missed. These programs also provide work experience, access to top-of-the-line gear, and opportunities to form lasting friendships.
                    </p>
                    <p>
                        Sustainability is a key focus of the program. Students rent gear to ensure it’s reused over time and learn how to care for and repair it, extending its lifespan and reducing waste. The goal is to make outdoor activities more accessible and instill a lifelong appreciation for nature.
                    </p>

                    <ImpactReporth4>Earth Day Campaign</ImpactReporth4>
                    <p>
                        We believe protecting the planet starts in our own backyard. For Columbia’s 2024 Earth Day campaign, we <a href='https://oceanconservancy.org/about/partner/columbia-sportswear/' target='_blank' rel='noopener noreferrer'>partnered</a> with <a href='https://oceanconservancy.org' target='_blank' rel='noopener noreferrer'>Ocean Conservancy</a>, an organization dedicated to evidence-based solutions for a healthier ocean and the communities and wildlife that depend on it. To support the fight for trash-free tides and trails, we encouraged consumers to download <a href='https://oceanconservancy.org/trash-free-seas/international-coastal-cleanup/clean-swell-app/' target='_blank' rel='noopener noreferrer'>Ocean Conservancy’s Clean Swell®</a> trash collection app. 
                    </p>
                    <AspectRatio ratio={16 / 9}>
                        <iframe 
                            src="https://www.youtube.com/embed/Bcsci3OM4zc?si=OvYr-kdPHOiP-_0a" 
                            title="YouTube video player" 
                            frameborder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                            referrerpolicy="strict-origin-when-cross-origin" 
                            allowfullscreen
                        />
                    </AspectRatio>

                    <ImpactReporth4>Columbia x National Park Foundation partnership</ImpactReporth4>
                    <p>
                        The Columbia brand has partnered with the National Park Foundation since 2013, and began supporting the <i>Open OutDoors for Kids</i> program in 2019. This program helps connect students to national parks through field trips, classroom activities, and hands-on educational experiences.
                    </p>

                    <ImpactReporth4>Columbia Canada x Trans Canada Trail partnership</ImpactReporth4>
                    <Image src={tctImg} alt='Columbia Canada employees' />
                    <p>
                        The Columbia brand in Canada has a multi-year partnership with Trans Canada Trail, the longest trail network in the world. As an official sponsor, Columbia supports the Trail Care program, which funds projects to repair, improve, and increase accessibility along the  trail. In 2024, we supported Trans Canada Trail in three big ways:
                    </p>
                    <ul>
                        <li>
                            <ImpactReporth5>Columbia Staff Clean Up</ImpactReporth5>
                            <p>
                                In May 2024, Columbia Canada employees used paid volunteer hours to participate in a trail clean-up near the Columbia Canada office, helping to remove trash and maintain the trail.
                            </p>
                        </li>
                        <li>
                            <ImpactReporth5>Tough Mother Funder</ImpactReporth5>
                            <p>
                                Customers at our Canadian Retail Outlet Stores were invited to donate to the Trans Canada Trail at checkout through the Tough Mother Funder program, supporting trail maintenance efforts.
                            </p>
                        </li>
                        <li>
                            <ImpactReporth5>Product Donations</ImpactReporth5>
                            <p>
                                The Columbia brand provided product to Trans Canada Trail staff, board members, and influencers. Additional product was also donated for use in Trans Canada Trail events and activations.
                            </p>
                        </li>
                    </ul>

                    <ImpactReporth4>Mountain Hardwear x Leave No Trace partnership</ImpactReporth4>
                    <SimpleGrid columns={{ base: 1, md: 2 }} gap={1}>
                        <Image src={leaveNoTrace1Img} alt='Leave no trace' />
                        <Image src={leaveNoTrace2Img} alt='Team picture' />
                    </SimpleGrid>
                    <p>
                        Mountain Hardwear was named the <a href='https://www.mountainhardwear.com/12-20_PressCenter_LNT.html' target='_blank' rel='noreferrer noopener'>2024 Leave No Trace Corporate Partner of the Year</a>, recognizing the brand’s commitment to environmental stewardship and sustainable outdoor practices. Throughout the year, the company actively promoted Leave No Trace principles and engaged in meaningful conservation efforts.
                    </p>
                    <p>
                        One highlight of the year was a volunteer initiative in the Bay Area, where employees contributed over 100 hours to environmental projects. Mountain Hardwear also helped expand the Leave No Trace ambassador program, with athletes Shayna Unger and Scott Lehmann joining as ambassadors to amplify the message of responsible outdoor practices.
                    </p>
                    <p>
                        In addition, the company co-presented at outdoor festivals, educating thousands on Leave No Trace principles, and proudly sponsored the Leave No Trace Global Summit in celebration of the organization’s 30th anniversary.
                    </p>

                    <ImpactReporth4>Mountain Hardwear x American Mountain Guides Association (AMGA)</ImpactReporth4>
                    <Image src={amgaImg} alt='Climbers' />
                    <p>
                        In partnership with the American Mountain Guides Association (AMGA), Mountain Hardwear offered 11 scholarships in 2024 for the annual LGBTQIA2S+ Single Pitch Instructor Course.
                    </p>
                    <p>
                        These courses are designed to meet the specific needs of participants, providing the training and support required to succeed in climbing instruction. By prioritizing inclusivity and representation, Mountain Hardwear and AMGA aim to encourage more people from diverse backgrounds to engage in climbing and pursue leadership roles within the sport. This effort strengthens the climbing community while promoting a culture of acceptance and empowerment for all identities.
                    </p>
                    <p>
                        Over the past five years, the program has helped certify 14 LGBTQIA2S+ individuals as Single Pitch Instructors, the AMGA’s entry-level climbing guide certification. These certified instructors now serve as leaders and role models, helping diversify the climbing world and inspire others in the community. <a href="https://www.mountainhardwear.com/affinity-programs.html">Learn more here.</a>
                    </p>
                </div>
            </section>

            <section style={{ marginTop: 'var(--space-2xl)' }}>
                <div className='container flow'>
                    <p>
                        To learn more about each brand’s community impact initiatives and nonprofit partnerships, check out their websites:
                    </p>
                    <ul>
                        <li><a href="https://www.columbia.com/corporate-responsibility/" target='_blank' rel='noreferrer noopener'>Columbia</a></li>
                        <li><a href="https://www.sorel.com/ocean-conservancy.html" target='_blank' rel='noreferrer noopener'>SOREL</a></li>
                        <li><a href="https://www.mountainhardwear.com/nonprofit-partners.html" target='_blank' rel='noreferrer noopener'>Mountain Hardwear</a></li>
                        <li><a href="https://www.prana.com/sustainability/membership-and-cause-partners.html" target='_blank' rel='noreferrer noopener'>prAna</a></li>
                    </ul>
                </div>
            </section>
            
            <ImpactReportPrevNextNav
                prevText='About Us and 2024 Highlights'
                prevLink='/corporate-responsibility/impact/2024'
                nextText='Sustaining Places'
                nextLink='/corporate-responsibility/impact/2024/sustaining-places'
            />
            
        </ImpactReportLayout>
    );
}
